export default "__VITE_ASSET__Df6EmR5T__"